var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgVerifiedTagIcon = function SvgVerifiedTagIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "solid/actions/approved"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22.9365C17.5228 22.9365 22 18.4594 22 12.9365C22 7.41368 17.5228 2.93652 12 2.93652C6.47715 2.93652 2 7.41368 2 12.9365C2 18.4594 6.47715 22.9365 12 22.9365ZM16.592 10.397C16.8463 10.0701 16.7874 9.59885 16.4605 9.34454C16.1335 9.09024 15.6623 9.14914 15.408 9.4761L11.401 14.628C11.3119 14.7425 11.1443 14.7574 11.0364 14.6603L8.50173 12.3791C8.19385 12.102 7.71963 12.127 7.44254 12.4348C7.16544 12.7427 7.1904 13.2169 7.49828 13.494L10.033 15.7752C10.7881 16.4549 11.9613 16.3508 12.585 15.5489L16.592 10.397Z",
    fill: "#389E0D"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVerifiedTagIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "verifiedTagIcon.6c655d6b6a2cca6c83d0a778d1cb1e70.svg";